// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#root {
  height: 100%;
  width: 100%;
}

body,
html {
  height: 100%;
  margin: 0;
  padding: 0;
  scrollbar-gutter: stable;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,wBAAwB;AAC1B","sourcesContent":["#root {\n  height: 100%;\n  width: 100%;\n}\n\nbody,\nhtml {\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  scrollbar-gutter: stable;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
